module.exports = __webpack_public_path__ + "static/media/button.95b904e4.svg";